import { createBrowserRouter } from 'react-router-dom';

// project-imports
import NavigationRoutes from './NavigationRoutes';
import PagesRoutes from './PagesRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [PagesRoutes, NavigationRoutes],
  {
    // Prefer explicit app base name, but fall back to Vite's base URL.
    basename: import.meta.env.VITE_APP_BASE_NAME ?? import.meta.env.BASE_URL ?? '/'
  }
);

export default router;
